import API from 'services/TAPS_API';

export default function createPdf(data) {
  return API.request({
    method: 'POST',
    url: '/notification/paymentSearch',
    data,
  });
}
